import { Component, input } from '@angular/core';
import { CrntIcon } from '@essent/current-web-angular';

import type { RfaPrefixSuffix } from '../../../models';

@Component({
  selector: 'rfa-prefix-suffix',
  standalone: true,
  templateUrl: './rfa-prefix-suffix.component.html',
  imports: [CrntIcon],
  styleUrls: ['./rfa-prefix-suffix.component.scss'],
})
export class RfaPrefixSuffixComponent {
  public readonly prefixSuffix = input.required<RfaPrefixSuffix>();
}
